import axios from 'axios'

export default {
    getMediaImageUrls (mediaId) {
        return axios.get('/api/medias/' + mediaId + '/images')
    },

    search (query, page = null, paginationSize = null) {
        return axios.post('/api/videos/search', {
            query: query,
            page: page,
            pagination_size: paginationSize
        })
    },

    getVideo (mediaId) {
        return axios.get('/api/videos/' + mediaId)
    }
}
